import React from 'react';
import { HomeSectionShell } from './HomeSectionShell';
import { SUCCESS_STORIES, SUCCESS_STORIES_SECTION } from './homePageConstants';

export const SuccessStoriesSection: React.FC = () => (
  <HomeSectionShell
    id="success-stories"
    title={SUCCESS_STORIES_SECTION.title}
    subtitle={SUCCESS_STORIES_SECTION.subtitle}
  >
    <div className="home-card-grid home-card-grid--three">
      {SUCCESS_STORIES.map((story) => (
        <article
          key={story.id}
          className={`home-story-card${story.isComingSoon ? ' home-story-card--coming-soon' : ''}`}
        >
          <h3 className="home-story-card__title">{story.title}</h3>
          {story.role ? <p className="home-story-card__role">{story.role}</p> : null}
          <p className="home-story-card__excerpt">{story.excerpt}</p>
        </article>
      ))}
    </div>
  </HomeSectionShell>
);
